<template>
  <div class="container mt-0 mb-4">
    <div class="card shadow-sm p-4 bg-light">
      <!-- Encabezado -->
      <div class="d-flex align-items-center mb-4">
        <button class="btn btn-outline-secondary me-3" @click="volver">
          ← Regresar
        </button>
        <h3 class="m-0 flex-grow-1 text-center">Notas de supervisión de limpieza</h3>
      </div>

      <!-- Tabla de Notas -->
      <div v-if="notas.length">
        <table class="table table-bordered table-striped">
          <thead class="table-light">
            <tr>
              <th>Habitación</th>
              <th>Fecha</th>
              <th>Evaluación</th>
              <th>Observaciones</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(nota, index) in notas" :key="index">
              <td class="align-middle text-center">
                <strong>{{ nota.NumeroHabitacion }}</strong>
              </td>
              <td class="align-middle">
                {{ formatDate(nota.Fecha) }}
              </td>
              <td>
                <div class="evaluacion-grid">
                  <div class="evaluacion-item">
                    <span class="evaluacion-label">🧹 Limpieza:</span>
                    <span class="badge" :class="getBadgeClass(nota.CalidadLimpieza)">
                      {{ getLabel(nota.CalidadLimpieza) }}
                    </span>
                  </div>
                  <div class="evaluacion-item">
                    <span class="evaluacion-label">🧻 Papel:</span>
                    <span class="badge" :class="getBadgeClass(nota.CalidadPapel)">
                      {{ getLabel(nota.CalidadPapel) }}
                    </span>
                  </div>
                  <div class="evaluacion-item">
                    <span class="evaluacion-label">🚿 Ducha:</span>
                    <span class="badge" :class="getBadgeClass(nota.CalidadDucha)">
                      {{ getLabel(nota.CalidadDucha) }}
                    </span>
                  </div>
                  <div class="evaluacion-item">
                    <span class="evaluacion-label">🛏️ Cama:</span>
                    <span class="badge" :class="getBadgeClass(nota.CalidadCama)">
                      {{ getLabel(nota.CalidadCama) }}
                    </span>
                  </div>
                  <div class="evaluacion-item">
                    <span class="evaluacion-label">📋 Otros:</span>
                    <span class="badge" :class="getBadgeClass(nota.CalidadOtros)">
                      {{ getLabel(nota.CalidadOtros) }}
                    </span>
                  </div>
                </div>
              </td>
              <td class="align-middle">
                <div class="nota-text">{{ nota.NotaSupervision || '-' }}</div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div v-else>
        <p class="text-center text-muted">No hay notas registradas.</p>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { API_URL } from '@/config/config.js'

export default {
  name: 'NotasSupervision',
  data() {
    return {
      notas: []
    }
  },
  async mounted() {
    try {
      const res = await axios.get(`${API_URL}/reservacion-habitacion/notas-supervision`)
      this.notas = res.data
    } catch (error) {
      console.error('Error al cargar notas:', error)
    }
  },
  methods: {
    volver() {
      this.$router.push('/inicio') // ajusta la ruta si es diferente
    },
    formatDate(fecha) {
      if (!fecha) return '-';
      const date = new Date(fecha);
      return date.toLocaleDateString('es-GT', {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      });
    },
    getLabel(calidad) {
      if (!calidad) return 'N/A';
      return calidad === 'bueno' ? '✓ Bueno' : '✗ Malo';
    },
    getBadgeClass(calidad) {
      if (!calidad) return 'bg-secondary';
      return calidad === 'bueno' ? 'bg-success' : 'bg-danger';
    }
  }
}
</script>

<style scoped>
.table th,
.table td {
  vertical-align: middle;
}

.evaluacion-grid {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.evaluacion-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.evaluacion-label {
  font-size: 0.875rem;
  font-weight: 500;
  min-width: 90px;
}

.badge {
  font-size: 0.75rem;
  padding: 0.35em 0.65em;
  font-weight: 600;
}

.nota-text {
  font-size: 0.9rem;
  color: #495057;
  line-height: 1.5;
  max-width: 300px;
  word-wrap: break-word;
}

@media (max-width: 768px) {
  .evaluacion-grid {
    gap: 0.35rem;
  }

  .evaluacion-label {
    font-size: 0.8rem;
    min-width: 80px;
  }
}
</style>
